import React from 'react';
import { isIE } from 'react-device-detect';
//import './UnsupportedBrowserBanner.scss';

export class UnsupportedBrowserBanner extends React.PureComponent {
  render() {
    if (isIE) {
      return (
        <div className="unsupported-browser-banner">
          Your browser is not compatible with Blackbird. Please switch to
          Chrome, Firefox, or Microsoft Edge.
        </div>
      );
    }

    return <div></div>;
  }
}
